import React from 'react';

/**
 * 개선된 AlertModal 컴포넌트
 * @param {boolean} isVisible - 모달 표시 여부
 * @param {function} onClose - 모달을 닫을 때 호출되는 함수 (필수)
 * @param {string} message - 모달 내용
 * @param {function} [callback] - '확인' 버튼 클릭 후, 모달이 닫힌 뒤 실행될 선택적 콜백 함수
 */
export const AlertModal = ({ isVisible, onClose, message, callback }) => {
    if (!isVisible) return null;

    // '확인' 버튼 클릭 시 실행될 핸들러
    const handleClose = () => {
        // 1. 부모에게 모달을 닫으라고 알림
        onClose();
        // 2. 콜백 함수가 있으면 실행
        if (callback) {
            callback();
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 m-4 w-full max-w-sm">
                <h3 className="text-lg font-semibold mb-4 text-center text-gray-900">알림</h3>
                <div className="mb-6 text-center text-gray-700 leading-relaxed whitespace-pre-wrap">
                    {message}
                </div>
                <div className="flex justify-center">
                    <button
                        onClick={handleClose}
                        className="w-full px-6 py-3 bg-amber-500 text-white rounded-lg active:bg-amber-600 font-medium"
                    >
                        확인
                    </button>
                </div>
            </div>
        </div>
    );
};
